export enum REFERENTIEL_TYPE {
  METIER = 'Métier',
  FORMATEUR = 'Formateur',
  SCIENCES_ET_CULTURE = 'SciencesEtCulture',
  TRANSVERSE = 'Transverse',
  COMPAGNONNIQUE = 'Compagnonnique',
}
